(() => {
  const config = document.querySelector('#tm-bundle-config');
  if (!config) return;
  const {groups, labels, currency, productHandle, root:baseRoot} = JSON.parse(config.textContent);
  Object.keys(labels).forEach(key => {labels[key] = labels[key].replace(/&amp;/g, '&');});
  const root = baseRoot.endsWith('/') ? baseRoot : baseRoot + '/';
  const host = document.querySelector('[data-tm-bundles]');
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency}).format(cents / 100);
  const format = (key, values = {}) => Object.entries(values).reduce((text, [key, value]) => text.replaceAll('[' + key + ']', value), labels[key]);
  const node = (tag, text, className) => {const el = document.createElement(tag); if (text) el.textContent = text; if (className) el.className = className; return el;};
  const cache = new Map();
  const getProduct = handle => {
    if (!cache.has(handle)) cache.set(handle, fetch(root + 'products/' + handle + '.js').then(r => {if (!r.ok) throw Error(); return r.json();}));
    return cache.get(handle);
  };
  let busy = false;
  let revision = 0;
  async function render() {
    if (busy) return;
    const current = ++revision;
    try {
      const response = await fetch(root + 'cart.js', {cache:'no-store'});
      if (!response.ok) throw Error();
      const cart = await response.json();
      const selected = groups.filter(group => productHandle ? group.handles.includes(productHandle) : cart.items.some(item => group.handles.includes(item.handle)));
      const panels = await Promise.all(selected.map(async group => {
        const items = cart.items.filter(item => group.handles.includes(item.handle));
        const count = items.reduce((sum, item) => sum + item.quantity, 0);
        const remainder = count % group.quantity;
        const needed = remainder ? group.quantity - remainder : group.quantity;
        const panel = node('section', null, 'tm-bundle-panel');
        panel.append(node('h2', labels[group.key]));
        panel.append(node('p', format('offer', {quantity:group.quantity, price:new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(group.total / 100)})));
        const allocations = items.flatMap(item => item.line_level_discount_allocations || []);
        const actualSavings = allocations.filter(a => a.discount_application.title === group.discountTitle).reduce((sum, a) => sum + a.amount, 0);
        if (actualSavings > 0) panel.append(node('p', format('applied', {savings:money(actualSavings)}), 'tm-bundle-success'));
        else if (count >= group.quantity) panel.append(node('p', labels.verify));
        if (productHandle) panel.append(node('p', labels.reminder));
        if (!count || remainder || actualSavings === 0) panel.append(node('p', format(needed === 1 ? 'remaining_one' : 'remaining', {count:needed})));
        else panel.append(node('p', labels.another));
        const details = node('details');
        details.open = !productHandle && (remainder > 0 || actualSavings === 0);
        details.append(node('summary', labels.browse));
        const grid = node('div', null, 'tm-bundle-grid');
        const products = await Promise.allSettled(group.handles.map(getProduct));
        products.forEach(result => {
          if (result.status !== 'fulfilled') return;
          const product = result.value;
          const variants = product.variants.filter(v => v.available);
          if (!variants.length) return;
          const card = node('div', null, 'tm-bundle-card');
          const link = node('a', product.title);
          link.href = root + 'products/' + product.handle;
          if (product.featured_image) {
            const image = node('img');
            const imageUrl = new URL(product.featured_image, location.origin);
            imageUrl.searchParams.set('width', '240');
            image.src = imageUrl.href; image.alt = product.title; image.width = 120; image.height = 150; image.loading = 'lazy';
            card.append(image);
          }
          card.append(link);
          const select = node('select');
          select.setAttribute('aria-label', format('options', {product:product.title}));
          const placeholder = node('option', labels.choose); placeholder.value = ''; placeholder.disabled = true; placeholder.selected = true; select.append(placeholder);
          variants.forEach(variant => {const option = node('option', variant.title + ' · ' + money(variant.price)); option.value = variant.id; select.append(option);});
          const price = node('p', labels.individual, 'tm-bundle-small');
          const button = node('button', labels.add, 'tm-button'); button.type = 'button'; button.disabled = true;
          select.addEventListener('change', () => {button.disabled = false;});
          const status = node('p', null, 'tm-bundle-small'); status.setAttribute('role', 'status');
          button.addEventListener('click', async () => {
            if (busy || !select.value) return;
            busy = true; button.disabled = true; button.textContent = labels.adding;
            try {
              const response = await fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:Number(select.value), quantity:1}]})});
              const result = await response.json();
              if (!response.ok) throw Error(typeof result.description === 'string' ? result.description : labels.error);
              location.assign(root + 'cart');
            } catch (error) {status.textContent = error.message || labels.error; button.disabled = false; button.textContent = labels.add; busy = false;}
          });
          card.append(select, price, button, status); grid.append(card);
        });
        if (!grid.children.length) grid.append(node('p', labels.unavailable));
        details.append(grid); panel.append(details, node('p', labels.terms, 'tm-bundle-small'));
        return panel;
      }));
      if (revision !== current) return;
      host.replaceChildren(...panels); host.hidden = panels.length === 0;
    } catch {host.hidden = true;}
  }
  render();
  document.addEventListener('cart:updated', render);
  if (window.jQuery) window.jQuery(document).ajaxSuccess((event, xhr, settings) => {if (/\/cart\/(add|change|update|clear)/.test(settings.url || '')) render();});
  window.addEventListener('pageshow', event => {if (event.persisted) render();});
})();
